import { graphql } from '@/generated/gql';

export const ANALYSE_QUOTE_MUTATION = graphql(/* GraphQL */ `
  mutation AnalyzeQuote($data: SvbrgQuoteAnalysisInput!) {
    sevenbridges {
      quote {
        analyse(data: $data) {
          id
          fileId
        }
      }
    }
  }
`);
